import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCFiBlox6eF1jIqN1i3wB-fgzjPBZjLG7I",
  authDomain: "evaldocente-af349.firebaseapp.com",
  projectId: "evaldocente-af349",
  storageBucket: "evaldocente-af349.firebasestorage.app",
  messagingSenderId: "1013245510070",
  appId: "1:1013245510070:web:32b54da33fd72ebe67c117",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const microsoftProvider = new OAuthProvider("microsoft.com");

// Forzar el uso del Tenant ID institucional para evitar el error AADSTS50194
microsoftProvider.setCustomParameters({
  tenant: "0507e5ce-0f95-49aa-abde-c90dcdedbd12",
});

export const googleProvider = new GoogleAuthProvider();
